var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bk-itm" }, [
    _vm.viewMode == "vertical" && _vm.initialized
      ? _c(
          "article",
          { staticClass: "productTile itemCategoryProduct" },
          [
            _c("bkAddToWishlist", {
              attrs: { "variation-id": _vm.item.variation.id },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "picture produkt_picture" },
              [
                _c("add-to-basket", {
                  staticClass: "add-to-basket",
                  attrs: {
                    "variation-id": _vm.item.variation.id,
                    "is-salable":
                      !!_vm.item.filter && _vm.item.filter.isSalable,
                    "has-children":
                      !!_vm.item.filter && _vm.item.filter.hasActiveChildren,
                    "minimum-quantity": _vm.item.variation.minimumOrderQuantity,
                    "has-order-properties": _vm.item.hasOrderProperties,
                    "has-required-order-property":
                      _vm.item.hasRequiredOrderProperty,
                    "item-url": _vm._f("itemURL")(
                      _vm.item,
                      _vm.urlWithVariationId
                    ),
                    "has-price": _vm._f("hasItemDefaultPrice")(_vm.item),
                    "item-type": _vm.item.item.itemType,
                    "one-click": true,
                    "use-large-scale": true,
                    "show-quantity": false,
                  },
                }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm._f("itemURL")(_vm.item),
                      tabindex: "-1",
                    },
                  },
                  [
                    _c("category-image-carousel", {
                      ref: "categoryImageCarousel",
                      attrs: {
                        "image-urls-data": _vm._f("itemImages")(
                          _vm.item.images,
                          _vm.imageUrlAccessor
                        ),
                        alt: _vm._f("itemName")(_vm.item),
                        title: _vm._f("itemName")(_vm.item),
                        "item-url": _vm._f("itemURL")(
                          _vm.item,
                          _vm.urlWithVariationId
                        ),
                        "enable-carousel": _vm.carouselEnabled,
                        "item-id": _vm.item.item.id,
                        "vimeo-video-id": _vm.vimeoVideoId,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "productInfoContainer infos" }, [
              _c(
                "div",
                { staticClass: "tagLine" },
                [
                  _vm.item.prices.rrp !== null &&
                  _vm.item.prices.rrp.price.value >
                    _vm.item.prices.default.unitPrice.value
                    ? _c("span", {
                        staticClass: "tag red",
                        class: {
                          currentSale:
                            _vm.ourFurniture && _vm.saleBadgeVisibleMode == "1",
                        },
                        domProps: {
                          innerHTML: _vm._s(
                            this.$options.filters.numberFormat(
                              (1 -
                                _vm.item.prices.default.unitPrice.value /
                                  _vm.item.prices.rrp.price.value) *
                                -100,
                              0,
                              ""
                            ) + " %"
                          ),
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showCurrentSaleTag
                    ? _c("div", { staticClass: "tag currentSale" }, [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(_vm.shopSaleCategoryItemText),
                          },
                        }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.storeSpecial && _vm.storeSpecial.id == 2
                    ? _c("div", { staticClass: "tag" }, [
                        _c("span", { domProps: { innerHTML: _vm._s("NEU") } }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.quickDelivery
                    ? _c("div", { staticClass: "tag quickDelivery" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              version: "1.1",
                              viewBox: "0 0 56.9 25.8",
                              "data-text": "Sofort lieferbar!",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                fill: "currentColor",
                                d: "M55.4,11.9l-3.9-4.8c-.7-.8-1.6-1.3-2.7-1.3h-2.4v-3c0-1.5-1.2-2.7-2.7-2.7h-23.1c-1.5,0-2.7,1.2-2.7,2.7v17.9c0,1.5,1.2,2.7,2.7,2.7h1.5c.6,1.4,2,2.4,3.7,2.4s3-1,3.7-2.4h17.6c.6,1.4,2,2.4,3.7,2.4s3.1-1,3.7-2.4c1.4-.1,2.5-1.3,2.5-2.7v-4.7c0-1.5-.5-2.9-1.4-4.1ZM25.8,24.3c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5,2.5,1.1,2.5,2.5-1.1,2.5-2.5,2.5ZM44.9,21.9h-15.2s0,0,0,0c0-2.2-1.8-4-4-4s-4,1.8-4,4,0,0,0,0h-1.2c-.7,0-1.2-.6-1.2-1.2v-3.4h25.6v4.7ZM49.5,7.4c.3.1.6.3.8.6l3.6,4.4h-3.2c-.7,0-1.2-.6-1.2-1.2v-3.7ZM50.8,24.3c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5,2.5,1.1,2.5,2.5-1.1,2.5-2.5,2.5ZM55.4,20.6c0,.5-.3.9-.7,1.1,0-2.2-1.8-3.9-4-3.9s-4,1.8-4,4,0,0,0,0h-.3V7.3h1.6v3.9c0,1.5,1.2,2.7,2.7,2.7h4.1c.3.6.5,1.3.5,2.1v4.7Z",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              staticClass: "st0",
                              attrs: {
                                d: "M14,2.1H6c-.6,0-1,.4-1,1s.4,1,1,1h8c.6,0,1-.4,1-1s-.4-1-1-1Z",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              staticClass: "st0",
                              attrs: {
                                d: "M10,9.1c0-.6-.4-1-1-1H1c-.6,0-1,.4-1,1s.4,1,1,1h8c.6,0,1-.4,1-1Z",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              staticClass: "st0",
                              attrs: {
                                d: "M14,14.1H6c-.6,0-1,.4-1,1s.4,1,1,1h8c.6,0,1-.4,1-1s-.4-1-1-1Z",
                              },
                            }),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.item.tags, function (tag) {
                    return [
                      [130, 131, 132, 133].includes(tag.id)
                        ? _c("span", {
                            class: "ct tag tagSize" + (parseInt(tag.id) - 129),
                            domProps: { innerHTML: _vm._s(tag.names.name) },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      tag.id == 105
                        ? _c("span", { staticClass: "tag tagFavorit" }, [
                            _vm._v("Bestseller"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      tag.id == 153
                        ? _c("span", { staticClass: "tag tagSet" }, [
                            _vm._v("Komplett-Set"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      tag.id == 14 && _vm.hasCrossPrice
                        ? _c("span", { staticClass: "tag tagDiscontinued" }, [
                            _vm._v("Abverkauf"),
                          ])
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "productName",
                  attrs: { href: _vm._f("itemURL")(_vm.item) },
                },
                [_vm._v(_vm._s(_vm._f("itemName")(_vm.item)))]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "details" }, [
                _vm.lengthWidthHeight != ""
                  ? _c("div", {
                      staticClass: "lengthWidthHeight",
                      domProps: { innerHTML: _vm._s(_vm.lengthWidthHeight) },
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.item.variation.isMain
                  ? _c("p", {
                      staticClass: "variationHint",
                      domProps: { innerHTML: _vm._s(_vm.variationHint) },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "itemPrice" }, [
                  _c("div", { staticClass: "prices" }, [
                    _vm.item.prices.rrp !== null &&
                    _vm.item.prices.rrp.price.value >
                      _vm.item.prices.default.unitPrice.value
                      ? _c("div", { staticClass: "price-view-port" }, [
                          _c("del", {
                            staticClass: "crossprice",
                            domProps: {
                              innerHTML: _vm._s(
                                "statt " +
                                  _vm.item.prices.rrp.unitPrice.formatted
                              ),
                            },
                          }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "price",
                      class: {
                        redPrice:
                          _vm.item.prices.rrp !== null &&
                          _vm.item.prices.rrp.price.value >
                            _vm.item.prices.default.unitPrice.value,
                      },
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.item.prices.default.unitPrice.formatted
                        ),
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  !(
                    _vm.item.unit.unitOfMeasurement === "C62" &&
                    _vm.item.unit.content === 1
                  )
                    ? _c("div", { staticClass: "category-unit-price small" }, [
                        _vm.item.variation.mayShowUnitPrice
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.item.prices.default.basePrice
                                ),
                              },
                            })
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]),
              ]),
            ]),
          ],
          1
        )
      : _vm.viewMode == "horizontal" && _vm.initialized
      ? _c("article", { staticClass: "itemCategoryProduct horizontal" }, [
          _c("div", { staticClass: "picture produkt_picture" }, [
            _c(
              "a",
              { attrs: { href: _vm._f("itemURL")(_vm.item) } },
              [
                _c("lazy-img", {
                  ref: "itemLazyImage",
                  attrs: {
                    "picture-class": "img-fluid",
                    "fallback-alt": _vm._f("itemName")(_vm.item),
                    title: _vm.firstImageTitle,
                    alt: _vm.firstImageAlternativeText,
                    "image-url": _vm._f("itemImage")(
                      _vm._f("itemImages")(
                        _vm.item.images,
                        _vm.imageUrlAccessor
                      )
                    ),
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "productInfoContainer" }, [
            _c("div", { staticClass: "productName" }, [
              _c(
                "a",
                {
                  staticClass: "thumb-title small",
                  attrs: { href: _vm._f("itemURL")(_vm.item) },
                },
                [_vm._v(_vm._s(_vm._f("itemName")(_vm.item)))]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "itemPrice" },
              [
                _c("add-to-basket", {
                  attrs: {
                    "variation-id": _vm.item.variation.id,
                    "is-salable":
                      !!_vm.item.filter && _vm.item.filter.isSalable,
                    "has-children":
                      !!_vm.item.item &&
                      _vm.item.item.salableVariationCount > 1,
                    "interval-quantity":
                      _vm.item.variation.intervalOrderQuantity || 1,
                    "minimum-quantity": _vm.item.variation.minimumOrderQuantity,
                    "maximum-quantity":
                      !!_vm.item.variation.maximumOrderQuantity &&
                      _vm.item.variation.maximumOrderQuantity > 0
                        ? _vm.item.variation.maximumOrderQuantity
                        : null,
                    "order-properties": _vm.item.properties.filter(function (
                      prop
                    ) {
                      return prop.property.isOderProperty
                    }),
                    "has-order-properties": _vm.item.hasOrderProperties,
                    "has-required-order-property":
                      _vm.item.hasRequiredOrderProperty,
                    "use-large-scale": false,
                    "show-quantity": false,
                    "item-url": _vm._f("itemURL")(
                      _vm.item,
                      _vm.urlWithVariationId
                    ),
                    "has-price": _vm._f("hasItemDefaultPrice")(_vm.item),
                    "has-graduated-price":
                      _vm.itemGraduatedPriceisCheapestSorting ||
                      _vm.itemGraduatedPricesalableVariationCount,
                    "item-type": _vm.item.item.itemType,
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "prices ml-auto" }, [
                  _vm.item.prices.rrp !== null &&
                  _vm.item.prices.rrp.price.value >
                    _vm.item.prices.default.unitPrice.value
                    ? _c("div", { staticClass: "price-view-port" }, [
                        _c("del", {
                          staticClass: "crossprice",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.item.prices.rrp.unitPrice.formatted
                            ),
                          },
                        }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "price",
                    class: {
                      redPrice:
                        _vm.item.prices.rrp !== null &&
                        _vm.item.prices.rrp.price.value >
                          _vm.item.prices.default.unitPrice.value,
                    },
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.item.prices.default.unitPrice.formatted
                      ),
                    },
                  }),
                ]),
              ],
              1
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.viewMode == "cart" && _vm.initialized
      ? _c(
          "article",
          { staticClass: "itemCategoryProduct cartCrossSellingItem" },
          [
            _c("div", { staticClass: "picture produkt_picture" }, [
              _c(
                "a",
                {
                  attrs: {
                    href: _vm._f("itemURL")(_vm.item),
                    "aria-label": "Empfehlung: Das passt dazu",
                    "click-count": "",
                  },
                },
                [
                  _c("lazy-img", {
                    ref: "itemLazyImage",
                    attrs: {
                      "picture-class": "img-fluid",
                      "fallback-alt": _vm._f("itemName")(_vm.item),
                      title: _vm.firstImageTitle,
                      alt: _vm._f("itemImageAlternativeText")(
                        _vm._f("itemImages")(
                          _vm.item.images,
                          _vm.imageUrlAccessor
                        )
                      ),
                      "image-url": _vm._f("itemImage")(
                        _vm._f("itemImages")(
                          _vm.item.images,
                          _vm.imageUrlAccessor
                        )
                      ),
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "itemContent" }, [
              _c("div", { staticClass: "info" }, [
                _c(
                  "a",
                  {
                    staticClass: "thumb-title small",
                    attrs: {
                      href: _vm._f("itemURL")(_vm.item),
                      "aria-label": "Empfehlung: Das passt dazu",
                      "click-count": "",
                    },
                  },
                  [_vm._v(_vm._s(_vm._f("itemName")(_vm.item)))]
                ),
                _vm._v(" "),
                _vm.item.attributes.length
                  ? _c(
                      "div",
                      { staticClass: "variation" },
                      [
                        _vm._l(_vm.item.attributes, function (attribute) {
                          return _c("span", {
                            staticClass: "attributeValue",
                            domProps: {
                              innerHTML: _vm._s(attribute.value.names.name),
                            },
                          })
                        }),
                        _vm._v(" "),
                        _vm.variationHint && !_vm.ourFurniture
                          ? _c("span", {
                              staticClass: "variationHint",
                              domProps: {
                                innerHTML: _vm._s(_vm.variationHint),
                              },
                            })
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.itemBundleQuantity
                  ? _c("span", {
                      staticClass: "bundleQuantitiy",
                      domProps: {
                        innerHTML: _vm._s(_vm.itemBundleQuantity + "&times;"),
                      },
                    })
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "action" }, [
                _c("div", { staticClass: "prices" }, [
                  _vm.item.prices.rrp !== null &&
                  _vm.item.prices.rrp.price.value >
                    _vm.item.prices.default.unitPrice.value
                    ? _c("div", { staticClass: "price-view-port" }, [
                        _c("del", {
                          staticClass: "crossprice",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.item.prices.rrp.unitPrice.formatted
                            ),
                          },
                        }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "price",
                    class: {
                      redPrice:
                        _vm.item.prices.rrp !== null &&
                        _vm.item.prices.rrp.price.value >
                          _vm.item.prices.default.unitPrice.value,
                    },
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.item.prices.default.unitPrice.formatted
                      ),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "basket" },
                  [
                    _c("add-to-basket", {
                      attrs: {
                        "variation-id": _vm.item.variation.id,
                        "is-salable":
                          !!_vm.item.filter && _vm.item.filter.isSalable,
                        "has-children":
                          !!_vm.item.filter &&
                          _vm.item.filter.hasActiveChildren,
                        "minimum-quantity":
                          _vm.item.variation.minimumOrderQuantity,
                        "has-order-properties": _vm.item.hasOrderProperties,
                        "has-required-order-property":
                          _vm.item.hasRequiredOrderProperty,
                        "item-url": _vm._f("itemURL")(
                          _vm.item,
                          _vm.urlWithVariationId
                        ),
                        "has-price": _vm._f("hasItemDefaultPrice")(_vm.item),
                        "item-type": _vm.item.item.itemType,
                        "one-click": true,
                        "use-large-scale": true,
                        "show-quantity": false,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }